export default "__VITE_ASSET__b731d4cb__"